import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import income from './images/income.png'

const IncomeVerification = props => {
  const { t } = useTranslation()
  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.income_verification.title', 'Income Verification'),
          description: (
            <Trans i18nKey="b.liv_score.view.income_verification.text">
              <strong>Income Verification</strong> is based on supporting documents (e.g. T4, pay
              slip, bank statement) uploaded within the Financial Details section of a renter's
              profile. The liv.rent team checks submitted documents to verify that the information
              matches the renter's stated income.
            </Trans>
          ),
          image: income
        })
      }
    />
  )
}

export default IncomeVerification
